import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/modules/_services/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(catchError(err => {
      if (err.status === 401 && err.error.message === 'Unauthorized') {
        return throwError(err);
      } else {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          if (((err.error.error === 'invalid_token' || err.error.error === 'invalid_grant')
          && err.error.error_description.includes('Invalid refresh token')) || err.error.error === 'unauthorized') {
            return throwError(err);
          } else {
            return this.handle401Error(request, next);
          }
        } else {
          return throwError(err);
        }
      }
    }));
  }

  handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.getRefreshToken(this.authService.getStoredRefreshToken()).pipe(
        switchMap((token: any) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(this.authService.getStoredAccessToken());
          return next.handle(this.addToken(request));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => next.handle(this.addToken(request))
        ));
    }
  }


  addToken(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.getStoredAccessToken()}`
      }
    });
  }

}
